module.exports = __webpack_public_path__ + "static/media/bg-contact.1256b124.png";